import React from 'react';
import { getPathName } from '../utils/pathCalculations';
import '../../../styles/modes/compareMode.css';

const PathInfoDisplay = ({ pathInfo, path, locations, type }) => {
  return (
    <div className={`path-info ${type} ${!pathInfo ? 'empty' : ''}`}>
      <h5>{type === 'auto' ? 'Auto Path (Algorithm Solution)' : 'Custom Path (Manual Planning)'}</h5>
      {pathInfo ? (
        <>
          <p className="distance-value">{pathInfo.distance.toFixed(2)} km</p>
          {pathInfo.flowCount ? (
            <p>Contains {pathInfo.flowCount} cargo flows</p>
          ) : pathInfo.pointCount ? (
            <p>Contains {pathInfo.pointCount} points</p>
          ) : (
            <p>Contains flows</p>
          )}
          <div className="path-sequence">
            <p>{pathInfo.flowCount ? 'Flow Summary:' : 'Path Sequence:'}</p>
            {pathInfo.flowCount && path.type === 'FeatureCollection' ? (
              <div className="flow-details">
                {/* Group flows by supply and display with auto mode styling */}
                {(() => {
                  // Colors for supply routes (same as auto mode)
                  const supplyColors = [
                    '#2196F3', '#FF9800', '#4CAF50', '#E91E63', '#9C27B0', '#FF5722',
                    '#00BCD4', '#795548', '#607D8B', '#FFC107', '#3F51B5', '#8BC34A'
                  ];
                  
                  const flowsBySupply = {};
                  path.features.forEach(feature => {
                    const props = feature.properties;
                    const supplyIndex = props.supplyIndex || 0;
                    const supplyKey = props.supply_number || props.warehouse_name || `S${supplyIndex}`;
                    if (!flowsBySupply[supplyKey]) {
                      flowsBySupply[supplyKey] = {
                        flows: [],
                        supplyIndex: supplyIndex,
                        totalQuantity: 0,
                        totalDistance: 0
                      };
                    }
                    flowsBySupply[supplyKey].flows.push({
                      demand: props.demand_number || props.customer_name || `D${props.demand_index}`,
                      quantity: props.quantity || 0,
                      distance: props.distance || 0
                    });
                    flowsBySupply[supplyKey].totalQuantity += props.quantity || 0;
                    flowsBySupply[supplyKey].totalDistance += props.distance || 0;
                  });
                  
                  return Object.entries(flowsBySupply).map(([supply, data]) => {
                    const routeColor = supplyColors[data.supplyIndex % supplyColors.length];
                    const cardStyle = {
                      marginBottom: '15px', 
                      padding: '10px', 
                      border: `2px solid ${routeColor}`, 
                      borderRadius: '5px', 
                      backgroundColor: `${routeColor}10`
                    };
                    
                    return (
                      <div key={supply} style={cardStyle}>
                        <h6 style={{color: routeColor, margin: '0 0 5px 0', display: 'flex', alignItems: 'center'}}>
                          <span style={{width: '12px', height: '12px', backgroundColor: routeColor, borderRadius: '50%', marginRight: '8px'}}></span>
                          {supply}
                        </h6>
                        <div style={{fontSize: '0.9em', color: '#666', marginBottom: '8px'}}>
                          Total Quantity: <strong>{data.totalQuantity}</strong> units | 
                          Total Distance: <strong>{data.totalDistance.toFixed(2)}</strong> km | 
                          Flows: <strong>{data.flows.length}</strong>
                        </div>
                        <div style={{fontSize: '0.85em'}}>
                          {data.flows.map((flow, idx) => (
                            <div key={idx} style={{marginBottom: '4px', display: 'flex', alignItems: 'center'}}>
                              <span style={{color: routeColor, fontWeight: 'bold'}}>{supply}</span>
                              <span style={{color: routeColor, margin: '0 4px'}}> → </span>
                              <span style={{color: '#333', backgroundColor: `${routeColor}20`, padding: '2px 6px', borderRadius: '3px'}}>
                                {flow.demand} ({flow.quantity} units, {flow.distance.toFixed(2)}km)
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  });
                })()}
              </div>
            ) : (
              <div className="path-sequence-value">{getPathName(path, locations)}</div>
            )}
          </div>
        </>
      ) : (
        <p className="empty-message">
          {type === 'custom' 
            ? 'No confirmed custom path. Please create and confirm a path in Custom Path mode.'
            : `No ${type} path data`
          }
        </p>
      )}
    </div>
  );
};

export default PathInfoDisplay; 